<div class="selected-plan">
  <ng-container
    *ngIf="
      (currentStep$ | async) === STEP_ENUM.SELECTED_DAY ||
      (currentStep$ | async) === STEP_ENUM.TICKET
    "
  >
    <div class="content-article">
      <div class="text-title">
        <span><mb-icon icon="ticket"></mb-icon></span>
        <h3 class="subtitle">Entradas a los parques temáticos de Disney</h3>
      </div>
      <div class="forms">
        <div class="content-datepicker">
          <mb-form-field appearance="light">
            <label mb-form-field-label for="dateSelected"
              >Fecha de inicio de las entradas</label
            >
            <input
              mb-form-field-input
              id="dateSelected"
              placeholder="Primer dia de ingreso"
              [mb-datepicker]="simpleDatepicker"
              [ngModel]="dateSelected"
              [minDate]="minDate"
              [maxDate]="maxDate"
              (dateSelected)="onDateSelected($event)"
            />
          </mb-form-field>
          <mb-datepicker #simpleDatepicker style="position: absolute"></mb-datepicker>
          <mb-notification>
            <p>
              Podés escoger el día de inicio entre el check-in y check-out de la reserva
            </p>
          </mb-notification>
        </div>
        <div [formGroup]="daySelectorFormGroup" class="forms__day-selector-wrapper">
          <mb-form-field appearance="light">
            <label mb-form-field-label for="day-selector">Cantidad de dias</label>
            <select mb-form-field-input id="day-selector" formControlName="day">
              <option [value]="0" *ngIf="hasRoomOnlyOption$ | async">En el parque</option>
              <option
                [value]="day"
                *ngFor="let day of daysAvailable$ | async; let i = index"
              >
                {{ day }}
              </option>
            </select>
          </mb-form-field>
        </div>
      </div>
    </div>

    <div class="content-article" *ngIf="daySelected > 0">
      <ng-container *ngIf="supplements$ | async; let supplements">
        <div
          class="content-carousel"
          *ngIf="supplements.length > 0; else emptySupplement"
        >
          <mb-carousel-custom [showDots]="false">
            <mb-carousel-item *ngFor="let supplement of supplements">
              <disney-ticket-combo
                [ticket]="supplement"
                [ticketDate]="dateSelected"
                [ticketSelected]="areTheSameTickets(supplement, ticketSelected$ | async)"
                (selected)="selectTicket($event, supplement)"
                [isExperts]="isExperts"
                [disabled]="isLoading$ | async"
              >
              </disney-ticket-combo>
            </mb-carousel-item>
          </mb-carousel-custom>
        </div>
        <ng-template #emptySupplement>
          <div class="error-empty">
            <div class="calendarError"></div>
            <p>
              <strong
                >No encontramos entradas disponibles para la cantidad de días
                seleccionadas, no te preocupes , probá con otra cantidad de días</strong
              >
            </p>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </ng-container>

  <div class="content-article" *ngIf="(currentStep$ | async) === STEP_ENUM.MEAL_PLAN">
    <div class="text-title">
      <span class="pool-icon"><mb-icon icon="pool-bar"></mb-icon></span>
      <h3 class="subtitle">
        Completá tu estadia con el plan de comida oficial de Disney
      </h3>
    </div>
    <div class="info">
      <div class="text-body">
        <p>
          Los planes aplican para todos los dias y todas las personas de tu grupo (a
          partir de 3 años de edad).
        </p>
      </div>
    </div>
    <div class="content-meal-plans">
      <div class="meal-plan-list">
        <ng-container *ngIf="ratesWithMealPlan | async as mealPlanRates">
          <mb-carousel-custom *ngIf="mealPlanRates.length > 0" [showDots]="false">
            <mb-carousel-item *ngFor="let rate of mealPlanRates">
              <meal-plan-disney
                [selected]="areTheSameRates(rate, rateSelected$ | async)"
                [included]="!mealPlanOptional"
                [rate]="rate"
                [ticketSelected]="ticketSelected"
                (selectedMealPlan)="disneyMealPlanSelected($event, rate)"
                [isExperts]="isExperts"
                [disabled]="isLoading$ | async"
              >
              </meal-plan-disney>
            </mb-carousel-item>
          </mb-carousel-custom>
        </ng-container>
      </div>
    </div>
  </div>
</div>
